import { Paper } from '@mantine/core'
import { modals } from '@mantine/modals'

import UpdateEscalationModal, {
  type ModalProps,
} from '../components/EscalationModals/updateEscalationModal.component'
import styles from './escalation-modal-view.module.scss'

export const openUpdateEscalationModal = (props: ModalProps) => {
  return modals.open({
    centered: true,
    size: 'auto',
    withCloseButton: false,
    closeOnClickOutside: false,
    children: (
      <Paper className={styles['modal-body']}>
        <UpdateEscalationModal {...props} />,
      </Paper>
    ),
  })
}
